module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M2 32h18c1.106 0 2-.894 2-2V12c0-1.106-.894-2-2-2H2c-1.106 0-2 .894-2 2v18c0 1.106.894 2 2 2zM24 6a2 2 0 0 1 2 2v14h4c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2H12c-1.106 0-2 .894-2 2v4h14z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/switch-window-1.js
// module id = 1443
// module chunks = 14